import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Alert } from '@mui/material';

import PriceListPriceInput from '../../../common/price_list_price_input';
import { getItemPriceListsNotificationData } from '../../../../../core/utils/notification_utils';
import useNotification from '../../../../../core/hooks/use_notification';
import { getItemPriceListsAction, getItemPriceListsState } from '../../../../../features/price/get_item_price_lists';

const PriceListFormPage = ({ productId }) => {
    const dispatch = useDispatch();
    const { showErrorMessage } = useNotification();

    const getItemPriceLists = useSelector(getItemPriceListsState);

    const refreshItemPriceLists = useCallback(() => {
        dispatch(getItemPriceListsAction(productId))
            .then(response => showErrorMessage(getItemPriceListsNotificationData(response)));
    }, [dispatch, productId, showErrorMessage]);

    useEffect(() => {
        refreshItemPriceLists();
    }, [refreshItemPriceLists]);

    return (
        <Box>
            {/* Ładny tekst informacyjny u góry */}
            <Alert severity="info" sx={{ mb: 2 }}>
                Jeżeli cena dla danego cennika nie zostanie uzupełniona, automatycznie zastosowana będzie domyślna cena sprzedaży.
            </Alert>

            { getItemPriceLists?.loading && (
                <Box mb={ 2 }>
                    <LinearProgress/>
                </Box>
            ) }

            { getItemPriceLists?.data && (
                <Box>
                    <TableContainer component={ Paper } variant="outlined">
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow sx={ { '& th': { backgroundColor: 'slate.50', fontWeight: 600 } } }>
                                    <TableCell sx={ { width: 100 } }>ID</TableCell>
                                    <TableCell>Nazwa cennika</TableCell>
                                    <TableCell sx={ { width: 200 } } align="center">Cena</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    getItemPriceLists?.data?.map(itemPriceList => (
                                        <TableRow key={ itemPriceList?.priceListId } hover>
                                            <TableCell sx={ { fontWeight: 600 } }>
                                                { itemPriceList?.priceListId }
                                            </TableCell>
                                            <TableCell>
                                                { itemPriceList?.priceListName }
                                            </TableCell>
                                            <TableCell>
                                                <PriceListPriceInput
                                                    productId={ productId }
                                                    initialPrice={ itemPriceList?.basicGrossPrice }
                                                    priceListId={ itemPriceList?.priceListId }
                                                    refreshList={ refreshItemPriceLists }
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            ) }
        </Box>
    );
};

export default PriceListFormPage;